export const LOGIN_STEPS = {
  cashApp: '1',
  phone: '2'
}
